import React, { useEffect, useState } from 'react';
import api from '../api';

import Card from './layout/Card';
import SectionHeader from './layout/SectionHeader';

export default function StatsSection({ token, setError }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!token) return;
    const fetch = async () => {
      try {
        const res = await api.get('/admin/stats', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStats(res.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch stats');
      }
    };
    fetch();
  }, [token]);

  if (!stats) return null;

  // show each key/value as a card
  const entries = Object.entries(stats);

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold mb-4 text-gray-800">Overview</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {entries.map(([key, value]) => (
          <Card key={key} className="text-center">
            <div className="text-sm uppercase text-gray-500">{key}</div>
            <div className="mt-2 text-3xl font-bold text-indigo-600">{value}</div>
          </Card>
        ))}
      </div>

      {/* charts placeholders */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Users Over Time" className="h-64 flex items-center justify-center text-gray-400">
          {/* replace with real chart component */}
          <span>Chart goes here</span>
        </Card>
        <Card title="Activity" className="h-64 flex items-center justify-center text-gray-400">
          <span>Chart goes here</span>
        </Card>
      </div>

      {/* recent activity */}
      <div>
        <SectionHeader title="Recent Activity" />
        <Card>
          <p className="text-gray-500">No recent events to show</p>
        </Card>
      </div>
    </div>
  );
}
